import { createGlobalStyle, ThemeContext } from 'styled-components'
import React, { useContext } from 'react'
import { GlobalStyle } from '@awaze/design-system.components.global-style'
import { AgnosticTheme } from '@awaze/design-system.components.awaze-theme-provider'

const GlobalStyleVars = createGlobalStyle`
  html {
  /* Color */
  --main-bg-color: ${({ theme }) => theme.ColorThemeBackgroundPage};
  }
`

export const GlobalStyling = (): JSX.Element => {
  const themeContext = useContext(ThemeContext) || AgnosticTheme

  return (
    <>
      <GlobalStyleVars theme={themeContext} />
      <GlobalStyle />
    </>
  )
}
